import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material";
import { TranslateService } from '@ngx-translate/core';
import { debug } from 'util';

@Component({
  selector: 'mesagge',
  templateUrl: './message.component.html'
})

export class MessageComponent implements OnInit {

  settings: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private translate: TranslateService) {
    if (!data.areValues) {
      this.translateParams(data.params);
    }
    this.settings = data;
  }

  ngOnInit(): void {

  }

  private translateParams(params: any) {
    if (!params) {
      params = {};
    }
    else if (!(params instanceof Object)) {
      return;
    }

    for (let key in params) {
      let value = params[key];
      this.translate.get(value.toString()).subscribe((res: string) => {
        params[key] = res;
      });
    }
  }
}
